export const changelog = [
  {
    title: "11/2026",
    changes: [
      "Market: split into Live and History views. Live has a Time left countdown, a Synced indicator and Buyout only; History shows concluded auctions with buyer, final price, outcome, period filters and a sold/total summary",
      "Market: filters and sorting are now buttons instead of dropdowns, and sorting applies to the whole result, not just the current page"
    ]
  },
  {
    title: "10/2026",
    changes: [
      "Added Global Quests and GQ Mob Guide: searchable history, player and duration stats, winner leaderboards, and mob targets - https://aardstats.com/gquests",
      "Added Epic Leaderboard: clear time rankings for small-group epics (Sea King's Dominion, Titans' Keep, The Cracks of Terra) - https://aardstats.com/epic-leaderboard",
      "Epic Leaderboard: bosses killed on each fastest run, the in-game note for the run (click \"Note #...\"), and a Boss draws chart showing how often each boss shows up",
      "Player page: new Overview / PK / Epics tabs - https://aardstats.com/player",
      "Player PK tab: opponents table, head-to-head, recent PK feed, activity heatmap, monthly chart, assists, streaks, HC and clan breakdowns, and milestones",
      "Player PK tab: head-to-head now has a Side by side comparison of kills, deaths, K/D, ranks, best streak, HC kills and fastest epic times",
      "Player Overview: K/D, kill participation, favorite target, most killed by, rank change arrows for the selected range, and best epic times",
      "Home: new Recently completed epics list - latest runs with clear time, players, bosses and the in-game note; click a run to see who was on it"
    ]
  },
  {
    title: "08/2026",
    changes: [
      "Market: Added \"Tokens\", \"Portals\", and \"Bonus loot\" item categories",
      "Market: Bonus loot weapons now show damage compared to a quest weapon of the same level",
      "Market: Added a Slot filter (e.g. wield, hold, head) to narrow down wearable items"
    ]
  },
  {
    title: "08/2026",
    changes: [
      "Added Market page: auction listings, bids, price/keyword search, item categories - https://aardstats.com/market",
      "Added Epics Dashboard: organizer/epic filters, run counts by hour - https://aardstats.com/epics-dashboard"
    ]
  },
  {
    title: "10/2025",
    changes: ["Added an option to subscribe/unsubscribe to boards"]
  },
  {
    title: "10/2025",
    changes: [
      "Boards/Forums, Threads, Notes from MUD - https://aardstats.com/boards"
    ]
  },
  {
    title: "08/2025",
    changes: ["Add Ice Age time", "Theme redesign"]
  },
  {
    title: "05/03/2025",
    changes: [
      "Leaderboards rework, Players V2: https://aardstats.com/leaderboards/players"
    ]
  },
  {
    title: "05/02/2025",
    changes: [
      "Update Epics Calendar at https://aardstats.com/epics",
      "Epics Calendar is dark theme; day based"
    ]
  },
  {
    title: "08/28/2024",
    changes: [
      "Added remaining races https://aardstats.com/race-modifiers",
      "Added all race affects https://aardstats.com/race-modifiers"
    ]
  },
  {
    title: "06/24/2024",
    changes: [
      "Updated Races to match MUD changes https://aardstats.com/race-modifiers"
    ]
  },
  {
    title: "05/25/2024",
    changes: [
      "Add Race Resists and Stats to https://aardstats.com/race-modifiers"
    ]
  },
  {
    title: "05/08/2024",
    changes: ["Race Modifiers page added https://aardstats.com/race-modifiers"]
  },
  {
    title: "05/05/2024",
    changes: [
      "Added screen /subclasses",
      "Added screen /races",
      "Added stat cards on Dashboard",
      "Removed Wanted on Dashboard",
      "Split OPK and HC activity tabs",
      "Added dropdowns in Header menu for more items"
    ]
  },
  {
    title: "04/26/2024",
    changes: [
      "Started tracking 8 new data points from gamestat 5",
      "Added Online, SHs, IMMs, Helpers on Dashboard, replacing PK data for current week",
      "Replaced Current Week on Dashboard with Hour Double Predictor"
    ]
  },
  {
    title: "03/24/2024",
    changes: [
      "Started tracking other activities",
      "Fixed reported bugs - UI and queries",
      "Added current player count on Dashboard"
    ]
  },
  {
    title: "11/24/23",
    changes: [
      "Add streaks to Player page",
      "Add recoded ranks to Player page",
      "Add charts to Player page",
      "Add shortcut links to player names on front page",
      "Style adjustments"
    ]
  },
  {
    title: "11/22/23",
    changes: ["Add streaks to Dashboard's Latest 10"]
  },
  {
    title: "11/20/23",
    changes: ["Add calendar for epics -- https://aardstats.com/epics"]
  },
  {
    title: "09/14/23",
    changes: [
      "[Epics] Added support for more time formats",
      "[Epics] Deleted, removed, cancelled epics are removed more frequently",
      "[Epics] Enhanced logging around epic notes to detect unhandled formats earlier"
    ]
  },
  {
    title: "07/10/23",
    changes: [
      "Resolved some responsiveness issues for epics",
      "Muted epics that are likely over"
    ]
  },
  {
    title: "07/06/23",
    changes: [
      "Dashboard changes for various time formats",
      "Added additional data to Last 10 table",
      "Theming changes for Last 10 table",
      "Label today's epics in red"
    ]
  },
  {
    title: "07/01/23",
    changes: ["Added note ID and original note subject to epic cards"]
  },
  {
    title: "06/28/23",
    changes: [
      "Changed time format for epics to match Google styleguide",
      "Added support for epics from other leaders that tag along after other epics",
      "Cleaned up discord messages"
    ]
  },
  {
    title: "06/25/23",
    changes: ["Added Epics under https://aardstats.com/"]
  },
  {
    title: "06/14/23",
    changes: [
      "Added Top 10 Most Killed and Most Killed section by under https://aardstats.com/player"
    ]
  },
  {
    title: "06/11/23",
    changes: [
      "Added Players dedicated page with lookups",
      "Added links from Dashboard Recent PKs to Feed",
      "Added links from Feed to Player pages"
    ]
  },
  {
    title: "06/06/23",
    changes: [
      "Changes to Discord webhooks",
      "Added recent activity: OPK/HC toggles",
      "Added recent activity: SETWANTED",
      "BE changes for consistency"
    ]
  },
  {
    title: "06/06/23",
    changes: [
      "Started tracking HC flag toggles",
      "Started tracking SETWANTEDs",
      "Re-organized stats displayed on Dashboard",
      "Behind the scenes changes for BE refactor",
      "Dashboard layout changes for UX"
    ]
  },
  {
    title: "06/01/23",
    changes: [
      "Started tracking PKer's level, subclass, race, tier",
      "Started tracking PKee's level, subclass, race, tier",
      "Wanted PKs are now marked WANTED (instead of PK)"
    ]
  },
  {
    title: "05/11/23",
    changes: ["Refactored header to be responsive", "Other UX/UI changes"]
  },
  {
    title: "05/08/23",
    changes: [
      "Changed `/leaderboards` filters to use URL params for hotlinking",
      "Fixed a bug with charts on dashboard",
      "Removed `Last week` standalone page"
    ]
  }
];
